/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	SubscriptionStartTrialPathParams,
	SubscriptionStartTrialRequest,
	SubscriptionStartTrialResponse,
} from '../types/SubscriptionStartTrial'

/**
 * POST /:organisation/profiles/:profile/trial
 * @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::startTrial
 */
export async function subscriptionStartTrial(
	organisation: SubscriptionStartTrialPathParams['organisation'],
	profile: SubscriptionStartTrialPathParams['profile'],
	data: SubscriptionStartTrialRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<SubscriptionStartTrialResponse>> {
	return axiosInstance.post(`/${organisation}/profiles/${profile}/trial`, data, config)
}
